export const APPLICATION_STATUS_STYLES = Object.freeze({
  approved: Object.freeze({ backgroundColor: "#C8FACC", color: "#37B349" }),
  draft: Object.freeze({ backgroundColor: "#DADADA", color: "#000000" }),
});

export const APPLICATION_STATUS_CHIP_SX = Object.freeze({
  height: 24,
  minWidth: 120,
  fontSize: 14,
  fontWeight: 700,
});

export const getApplicationStatusStyle = (status) =>
  APPLICATION_STATUS_STYLES[String(status || "").trim().toLowerCase()] || null;
